import { useContext } from "react";
import { AppContext } from "../App";
import { FiCpu, FiTrendingUp, FiLayers } from "react-icons/fi";

import { HiOutlineArrowNarrowRight, HiOutlineArrowLeft, HiOutlineArrowRight } from "react-icons/hi";
import { hospitalInfo } from "../content/hospitalContent";
import { IoMdArrowDropright } from "react-icons/io";
import Footer from "./Footer";

export default function TeleHealth2() {
  const appContext = useContext(AppContext);

  const services = [
    {
      icon: <FiCpu />,
      title: "Telemedicine & Remote Consultation",
      desc: "Remote consulting pipelines via designated secure platforms or telemetry apps tailored for Nanguba Care Program chronic disease management tracking."
    }
  ];

  return (
    <>
      <div className="pillar-container">
        <div className="pillar-header">
          <h2 className="pillar-title">TELEHEALTH</h2>
          <p className="pillar-subtitle">Extending modern healthcare capabilities beyond traditional brick-and-mortar limitations.</p>
        </div>

        <div className="row">
          {services.map((item, idx) => (
            <div 
              key={idx} 
              className="col-md-7 mx-auto bg-light p-3 p-md-5"
            >
              <div className="pillar-icon">{item.icon}</div>
              <h3 className="pillar-card-title">{item.title}</h3>
              <p className="pillar-card-desc">{item.desc}</p>
            </div>
          ))}

          <div className="hero-btns row g-2">
            <div className="col-md-6 mx-auto">
              <a href={hospitalInfo.patientUrl} target="_blank" rel="noreferrer" className="btn-sm btn-primary btn-modern">
                LOGIN TO PATIENT PORTAL FOR TELEHEALTH <HiOutlineArrowNarrowRight className="d-none d-md-inline-flex" size={22} /> 
              </a>
            </div>
            
          </div>
        </div>
      </div>
      <Footer/>
    </>
  );
}